import { AreaSelectionSummaryCard } from './area-selection-summary-card';

interface SelectionSummaryOverlayProps {
  selectedCount: number;
  visibleSelectedCount?: number;
  selectedIds: ReadonlySet<string | number>;
  onAddToDraft?: (ids: (string | number)[]) => void;
  onClearSelection: () => void;
  t: (key: string, options?: Record<string, unknown>) => string;
  /** Optional callback to trigger bulk-download for area-selected IDs */
  onBulkDownloadSpecs?: (ids: number[]) => void;
  /** When true, the bulk-download button is rendered in a disabled state */
  bulkDownloadDisabled?: boolean;
  /** Tooltip text shown when the bulk-download button is disabled */
  bulkDownloadDisabledReason?: string;
}

export function SelectionSummaryOverlay(props: SelectionSummaryOverlayProps) {
  return (
    <div className="absolute top-3 right-3 z-40">
      <AreaSelectionSummaryCard {...props} />
    </div>
  );
}
